import { createContext, useState, useContext, ReactNode } from 'react';

interface PrintContextType {
  isPrinting: boolean;
  setPrinting: (value: boolean) => void;
}

export const PrintContext = createContext<PrintContextType | undefined>(
  undefined,
);

export const usePrintContext = () => {
  const context = useContext(PrintContext);
  if (context === undefined) {
    throw new Error('usePrintContext must be used within a PrintProvider');
  }
  return context;
};

interface PrintProviderProps {
  children: ReactNode;
}

export const PrintProvider = ({ children }: PrintProviderProps) => {
  const [isPrinting, setIsPrinting] = useState(false);

  const setPrinting = (value: boolean) => {
    setIsPrinting(value);
  };

  return (
    <PrintContext.Provider value={{ isPrinting, setPrinting }}>
      {children}
    </PrintContext.Provider>
  );
};
